<template>
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512" :class="cls" :style="innerStyle" :stroke-width="strokeWidth" :stroke-linecap="strokeLinecap" :stroke-linejoin="strokeLinejoin" @click="onClick"><path fill="#00d6b9" d="m273.46 264.31 1.01-1.01c.65-.65 1.36-1.36 2.06-2.01l1.41-1.36 4.17-4.12 5.73-5.58 4.88-4.83 4.57-4.52 4.78-4.73 4.37-4.32 6.13-6.03c1.16-1.16 2.36-2.26 3.57-3.37 2.21-2.01 4.52-3.97 6.84-5.88 2.16-1.71 4.37-3.37 6.64-4.98 3.17-2.26 6.43-4.32 9.75-6.33 3.27-1.91 6.64-3.72 10.05-5.43 3.22-1.56 6.54-3.02 9.9-4.32 1.86-.75 3.77-1.41 5.68-2.06.96-.3 1.91-.65 2.92-.96a241.19 241.19 0 0 0-45.6-91.5c-4.17-5.18-10.51-8.19-17.14-8.19H128.97c-1.81 0-3.32 1.46-3.32 3.32 0 1.06.5 2.01 1.36 2.66 60.13 44.09 110 100.75 146.04 166l.4-.45Z"></path><path fill="#133c9a" d="M203.43 419.4c90.99 0 170.27-50.22 211.6-124.43 1.46-2.61 2.87-5.23 4.22-7.89a96.374 96.374 0 0 1-6.94 11.41c-.9 1.26-1.81 2.51-2.77 3.77-1.21 1.56-2.41 3.02-3.67 4.47a98.086 98.086 0 0 1-3.07 3.37 85.486 85.486 0 0 1-6.64 6.28c-1.31 1.11-2.56 2.16-3.92 3.17a76.24 76.24 0 0 1-4.78 3.42c-1.01.7-2.06 1.36-3.12 2.01-1.06.65-2.16 1.31-3.32 1.96a91.35 91.35 0 0 1-6.99 3.52c-2.06.9-4.17 1.76-6.28 2.56a82.5 82.5 0 0 1-7.04 2.26 86.613 86.613 0 0 1-10.81 2.31c-2.61.4-5.33.7-7.99.9-2.82.2-5.68.25-8.55.25-3.17-.05-6.33-.25-9.55-.6-2.36-.25-4.73-.6-7.09-1.01-2.06-.35-4.12-.8-6.18-1.31-1.11-.25-2.16-.55-3.27-.85-3.02-.8-6.03-1.66-9.05-2.51-1.51-.45-3.02-.85-4.47-1.31-2.26-.65-4.47-1.36-6.69-2.06-1.81-.55-3.62-1.16-5.43-1.76-1.71-.55-3.47-1.11-5.18-1.71l-3.52-1.21c-1.41-.5-2.87-1.01-4.27-1.51l-3.02-1.11c-2.01-.7-4.02-1.46-5.98-2.21-1.16-.45-2.31-.85-3.47-1.31-1.56-.6-3.07-1.21-4.63-1.81-1.61-.65-3.27-1.31-4.88-1.96l-3.17-1.31-3.92-1.61-3.02-1.26-3.12-1.36-2.71-1.21-2.46-1.11-2.51-1.16-2.56-1.21-3.27-1.51-3.42-1.61c-1.21-.6-2.41-1.16-3.62-1.76l-3.07-1.51A508.746 508.746 0 0 1 65.6 190.35c-1.26-1.31-3.32-1.41-4.68-.15-.65.6-1.06 1.51-1.06 2.41l.1 155.49v12.62c0 7.34 3.62 14.18 9.7 18.25 39.56 26.44 86.12 40.47 133.73 40.37"></path><path fill="#3370ff" d="M470.83 200.21c-30.72-15.03-65.86-18.25-98.79-9-1.41.4-2.77.8-4.12 1.21-.96.3-1.91.6-2.92.96-1.91.65-3.82 1.36-5.68 2.06-3.37 1.31-6.64 2.77-9.9 4.32-3.42 1.66-6.79 3.47-10.05 5.38-3.37 1.96-6.59 4.07-9.75 6.33-2.26 1.61-4.47 3.27-6.64 4.98-2.36 1.91-4.63 3.82-6.84 5.88-1.21 1.11-2.36 2.21-3.57 3.37l-6.13 6.03-4.37 4.32-4.78 4.73-4.57 4.52-4.88 4.83-5.68 5.63-4.17 4.12-1.41 1.36c-.65.65-1.36 1.36-2.06 2.01l-1.01 1.01-1.56 1.46-1.76 1.61c-15.13 13.93-32.02 25.84-50.17 35.54l3.27 1.51 2.56 1.21 2.51 1.16 2.46 1.11 2.71 1.21 3.12 1.36 3.02 1.26 3.92 1.61 3.17 1.31c1.61.65 3.27 1.31 4.88 1.96 1.51.6 3.07 1.21 4.63 1.81 1.16.45 2.31.85 3.47 1.31 2.01.75 4.02 1.46 5.98 2.21l3.02 1.11c1.41.5 2.82 1.01 4.27 1.51l3.52 1.21c1.71.55 3.42 1.16 5.18 1.71 1.81.6 3.62 1.16 5.43 1.76 2.21.7 4.47 1.36 6.69 2.06 1.51.45 3.02.9 4.47 1.31 3.02.85 6.03 1.71 9.05 2.51 1.11.3 2.16.55 3.27.85 2.06.5 4.12.9 6.18 1.31 2.36.4 4.73.75 7.09 1.01 3.22.35 6.38.55 9.55.6 2.87.05 5.73-.05 8.55-.25 2.71-.2 5.38-.5 7.99-.9 3.62-.55 7.24-1.36 10.81-2.31 2.36-.65 4.73-1.41 7.04-2.26a75.16 75.16 0 0 0 6.28-2.56 91.35 91.35 0 0 0 6.99-3.52c1.11-.6 2.21-1.26 3.32-1.96 1.11-.65 2.11-1.36 3.12-2.01 1.61-1.11 3.22-2.21 4.78-3.42 1.36-1.01 2.66-2.06 3.92-3.17 2.26-1.96 4.47-4.07 6.59-6.28 1.06-1.11 2.06-2.21 3.07-3.37 1.26-1.46 2.51-2.97 3.67-4.47a73.33 73.33 0 0 0 2.77-3.77c2.51-3.62 4.83-7.39 6.89-11.31l2.36-4.68 21.01-41.88.25-.5c6.94-14.98 16.39-28.45 28-39.97Z"></path></svg>
</template>

<script lang="ts">
import { defineComponent, computed, CSSProperties } from 'vue';
import { getPrefixCls } from '../../_utils/global-config';
import { isNumber } from '../../_utils/is';

export default defineComponent({
  name: 'IconLarkColor',
  props: {
    size: {
      type: [Number, String],
    },
    strokeWidth: {
      type: Number,
      default: 4
    },
    strokeLinecap: {
      type: String,
      default: 'butt',
      validator: (value: any) => {
        return ['butt', 'round', 'square'].includes(value);
      }
    },
    strokeLinejoin: {
      type: String,
      default: 'miter',
      validator: (value: any) => {
        return ['arcs', 'bevel', 'miter', 'miter-clip', 'round'].includes(value);
      }
    },
    rotate: Number,
    spin: Boolean
  },
  emits: {
    click: (ev: MouseEvent) => true,
  },
  setup(props, { emit }) {
    const prefixCls = getPrefixCls('icon');
    const cls = computed(() => [prefixCls, `${prefixCls}-lark-color`, { [`${prefixCls}-spin`]: props.spin }]);
    const innerStyle = computed(() => {
      const styles: CSSProperties = {};
      if (props.size) {
        styles.fontSize = isNumber(props.size) ? `${props.size}px` : props.size;
      }
      if (props.rotate) {
        styles.transform = `rotate(${props.rotate}deg)`;
      }
      return styles;
    });
    const onClick = (ev: MouseEvent) => {
      emit('click', ev);
    };

    return {
      cls,
      innerStyle,
      onClick,
    };
  }
});
</script>
